import { render, staticRenderFns } from "./BusinessWireframes.vue?vue&type=template&id=77faedc0"
import script from "./BusinessWireframes.vue?vue&type=script&lang=js"
export * from "./BusinessWireframes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports